import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, BookOpen, Star } from 'lucide-react';
import { CTAButton } from './Shared';
export const Hero = () => {
  return <div className="relative overflow-hidden pt-12 pb-8 md:pt-20 md:pb-12" data-id="element-114">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-goldLight/20 rounded-full blur-[140px] -z-10 pointer-events-none" data-id="element-115"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-x-[8px] space-y-[0px]" data-id="element-117">
          <div className="mb-3 w-full max-w-[200px] md:max-w-xs mx-auto" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/n3pKHMfJ9uUPT2ADomLmVQ/Baner.png" alt="Lumen Akasha" className="w-full h-auto max-h-[50px] md:max-h-[70px] object-contain rounded-xl mix-blend-multiply opacity-90" data-id="element-119" />
          </div>

          <h1 className="md:text-6xl lg:text-7xl font-serif font-bold mb-8 text-[20px]" data-id="element-120">
            Tu hogar en paz.
            <br data-id="element-121" />
            <span className="gold-gradient-text text-[24px]" data-id="element-122">Desde hoy.</span>
          </h1>

          <div className="mb-8 relative z-10" data-id="element-123">
            <img src="https://cdn.magicpatterns.com/uploads/132k8NWZWeGhDttiSA8YKx/Mockup_Limpieza_energetica_con_2_bonos.png" alt="Lumen Akasha Colección Limpieza Energética" className="w-full max-w-3xl mx-auto drop-shadow-[0_20px_50px_rgba(196,148,61,0.25)]" data-id="element-124" />
          </div>

          <div className="max-w-3xl mx-auto mb-8 space-y-3 px-4" data-id="element-125">
            <p className="md:text-xl font-bold text-brand-gold text-[14px]" data-id="element-126">
              Sistema completo de Limpieza Energética — Del diagnóstico a la
              abundancia
            </p>
            <p className="md:text-base text-brand-text/80 text-[12px]" data-id="element-127">
              Sin experiencia previa. Sin materiales raros.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-12 text-xs md:text-sm font-medium" data-id="element-128">
            <div className="flex items-center bg-brand-surfaceLight/50 px-4 py-2 rounded-full border border-brand-gold/15 whitespace-nowrap text-[10px]" data-id="element-129">
              <FileText className="w-4 h-4 mr-2 text-brand-gold shrink-0" data-id="element-130" />
              100% PDF
            </div>
            <div className="flex bg-brand-surfaceLight/50 px-4 py-2 rounded-full border border-brand-gold/15 whitespace-nowrap pl-[1px] pr-[1px] flex-row items-start justify-center" data-id="element-131">
              <Zap className="w-4 h-4 mr-2 text-brand-gold shrink-0" data-id="element-132" />
              Acceso en 5 min
            </div>
            <div className="flex items-center bg-brand-surfaceLight/50 px-4 py-2 rounded-full border border-brand-gold/15 whitespace-nowrap text-[10px]" data-id="element-133">
              <BookOpen className="w-4 h-4 mr-2 text-brand-gold shrink-0" data-id="element-134" />3
              Tomos + Bonos
            </div>
          </div>

          <div className="flex flex-col items-center space-y-6" data-id="element-135">
            <CTAButton className="text-xl px-10 py-5" data-id="element-136">
              → QUIERO MI COLECCIÓN AHORA
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-brand-muted" data-id="element-137">
              <div className="flex items-center text-[10px]" data-id="element-138">
                <Shield className="w-4 h-4 mr-1.5" data-id="element-139" /> Garantía 7 días
              </div>
              <div className="flex items-center text-[10px]" data-id="element-140">
                <Lock className="w-4 h-4 mr-1.5" data-id="element-141" /> Pago seguro
              </div>
              <div className="flex items-center text-[10px]" data-id="element-142">
                <CreditCard className="w-4 h-4 mr-1.5" data-id="element-143" /> Mercado Pago
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Social Proof Bar */}
      <div className="mt-12 border-y border-brand-gold/10 bg-brand-surface/50 py-4 pt-[1px] pb-[1px]" data-id="element-144">
        {/* Mobile: wrapped grid */}
        <div className="md:hidden flex flex-wrap justify-center gap-x-6 gap-y-2 px-4 text-[13px]" data-id="element-145">
          <div className="flex items-center" data-id="element-146">
            <span className="font-bold text-brand-gold mr-1.5" data-id="element-147">+300</span>
            hogares transformados
          </div>
          <div className="flex items-center" data-id="element-148">
            <span className="font-bold text-brand-gold mr-1.5" data-id="element-149">3</span> Tomos
            listos
          </div>
          <div className="flex items-center" data-id="element-150">
            <span className="font-bold text-brand-gold mr-1.5" data-id="element-151">2</span> Bonus
            incluidos
          </div>
          <div className="flex items-center" data-id="element-152">
            <Star className="w-3.5 h-3.5 text-brand-gold fill-brand-gold mr-1" data-id="element-153" />
            4.9/5 calificación
          </div>
          <div className="flex items-center" data-id="element-154">100% PDF descargable</div>
          <div className="flex items-center" data-id="element-155">
            <Zap className="w-3.5 h-3.5 text-brand-gold mr-1" data-id="element-156" /> Acceso
            inmediato
          </div>
        </div>

        {/* Desktop: horizontal row with dots */}
        <div className="hidden md:flex flex-row items-center space-x-6 justify-center whitespace-nowrap px-4" data-id="element-157">
          <div className="flex items-center text-[15px]" data-id="element-158">
            <span className="font-bold text-brand-gold mr-2" data-id="element-159">+300</span>
            hogares transformados
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-160"></div>
          <div className="flex items-center text-[15px]" data-id="element-161">
            <span className="font-bold text-brand-gold mr-2" data-id="element-162">3</span> Tomos
            listos
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-163"></div>
          <div className="flex items-center text-[15px]" data-id="element-164">
            <span className="font-bold text-brand-gold mr-2" data-id="element-165">2</span> Bonus
            incluidos
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-166"></div>
          <div className="flex items-center text-[15px]" data-id="element-167">
            <Star className="w-4 h-4 text-brand-gold fill-brand-gold mr-1" data-id="element-168" />
            4.9/5 calificación
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-169"></div>
          <div className="flex items-center text-[15px]" data-id="element-170">
            100% PDF descargable
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/30 shrink-0" data-id="element-171"></div>
          <div className="flex items-center text-[15px]" data-id="element-172">
            <Zap className="w-4 h-4 text-brand-gold mr-1" data-id="element-173" /> Acceso inmediato
          </div>
        </div>
      </div>
    </div>;
};